import { render, staticRenderFns } from "./EditOrDeleteShiftModal.vue?vue&type=template&id=4af65616&scoped=true"
import script from "./EditOrDeleteShiftModal.vue?vue&type=script&lang=js"
export * from "./EditOrDeleteShiftModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af65616",
  null
  
)

export default component.exports